import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/khb.module';
import { environment } from './environments/environment';

import {} from './app/khb.module';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
// .bootstrapModule()
  .catch(err => console.log(err));



// WEBPACK FOOTER //
// ./src/main.ts